class RecentlyViewed {
  run() {
    this.initialize();

    $(window).off('recentlyviewed:initialize').on('recentlyviewed:initialize', (e, data) => {
      this.initialize();
    });
  }


  initialize() {
    $('.widget-recently-viewed:not(.initialized)').each((i, el) => {
      const $widget = $(el);
      $widget.addClass('initialized');

      const count = Math.round($widget.find('.slider').children().length / 4);
      let current = 0;
      const slider = $widget.find('.slider').owlCarousel({
        loop: false,
        nav: false,
        responsive: {
          0: {
            items: 2,
            margin: 5
          },
          600: {
            items: 4,
            margin: 16
          },
          800: {
            items: 4,
            margin: 40
          }
        }
      });
      slider.on('changed.owl.carousel', (e) => {
        current = e.page.index;
        $widget.find('.widget-current').text(current + 1);
      });
      var move = () => {
        $widget.find('.widget-current').text(current + 1);
        slider.trigger('to.owl.carousel', [current]);
      };
      $widget.find('.widget-total').text(count);
      $widget.find('.widget-next').click(() => {
        if (current + 1 >= count) { return; }
        current++;
        move();
      });
      $widget.find('.widget-prev').click(() => {
        if (current - 1 < 0) { return; }
        current--;
        move();
      });
    });
  }
}


const recentlyViewed = new RecentlyViewed();
export default recentlyViewed;



// WEBPACK FOOTER //
// ./assets/scripts/widgets/recentlyViewed.js